<template lang="pug">
    .photo-contents
        .contents
            .photo
                img.frame(src="../assets/img/35_frame.png")
                //- ここが実際の写真箇所
                img.photo(:src="$store.getters.getDetail.media_url")

</template>
<style lang="scss" scoped>
.photo-contents > .contents {
    > .photo {
        width: 314px;
        height: 314px;

        @media screen and (max-width: 360px) {
            width: 280px;
            height: 280px;
        }

        @media #{$pc} {
            width: 391px;
            height: 391px;
        }
        position: relative;
        > img {
            width: 100%;
        }

        > .frame {
            position: absolute;
            top: 0;
            left: 0;
        }

        > .photo {
            object-fit: cover;
            width: 100%;
            height: 100%;
        }
    }
}
</style>
<script>
export default {
    props: {},
    data() {
        return {
            imgName: "7.jpg"
        };
    },
    computed: {
        imgUrl() {
            return require("@/assets/img/" + this.imgName);
        }
    }
};
</script>
